<template>
    <a-select
        mode="multiple"
        v-model:value="valueState"
        placeholder="Pilih Sales"
        allow-clear
        show-search
        show-arrow
        :not-found-content="state.loading ? undefined : 'Tidak ditemukan'"
        option-filter-prop="label"
        option-label-prop="label"
        @search="onSearch"
        @dropdownVisibleChange="dropdownVisibleChange"
        :loading="state.loading"
        v-bind="$attrs"
        style="width:300px">
        <a-select-option v-for="d in state.data" :key="d.id" :label="d.nopeg + ' - ' + d.fullname">
            <!-- eslint-disable vue/no-v-html -->
            <span v-html="highlight(d.nopeg + ' - ' + d.fullname)"></span>
            <!--eslint-enable-->
        </a-select-option>
        <template v-if="state.loading" #notFoundContent>
            <a-spin size="small" />
        </template>
    </a-select>
</template>

<script>
import { onMounted, watch, reactive } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce, pickBy } from 'lodash'

export default {
    props: {
        value: {
            type: [Array, Number, Object, String],
            default: null,
        },
        role_id: {
            type: [Array, Number, String],
            default: () => [],
        },
        wilayah_id: {
            type: [Array, Number, String],
            default: () => [],
        },
        parent_id: {
            type: [Array, Number, String],
            default: () => [],
        },
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const state = reactive({
            endpoint: '/api/filter/sales',
            loading: false,
            data: [],
            params: {
                q: '',
                role_id: props.role_id,
                parent_id: props.parent_id,
                wilayah_id: props.wilayah_id,
            },
        })

        const fetchData = () => {
            state.loading = true
            apiClient
                .get(state.endpoint, {
                    params: pickBy(state.params),
                })
                .then(({ data }) => {
                    state.data = data.sort((a, b) =>
                        a.fullname.toLowerCase() > b.fullname.toLowerCase() ? 1 : -1,
                    )
                })
                .finally(() => {
                    state.loading = false
                })
        }

        onMounted(() => {
            fetchData()
        })

        watch([
            () => props.wilayah_id,
            () => props.parent_id,
            () => props.role_id], () => {
            emit('update:value', [])
            state.params.wilayah_id = props.wilayah_id
            state.params.parent_id = props.parent_id
            state.params.role_id = props.role_id
        })

        watch(state.params, () => {
            fetchData()
        })

        const onSearch = debounce(value => {
            state.params.q = value
        }, 500)

        const highlight = (value) => {
            return value.replace(new RegExp(state.params.q, 'gi'), match => {
                return `<span style="background-color: yellow;">${match}</span>`
            })
        }

        const dropdownVisibleChange = value => {
            if (state.params.q !== null) {
                state.params.q = ''
            }
        }

        return {
            state,
            valueState: useVModel(props, 'value'),
            highlight,
            onSearch,
            dropdownVisibleChange,
        }
    },
}
</script>

<style></style>
